"use client";

import { c as _c } from "react/compiler-runtime";
import { useEffect } from "react";
import { useInstantSearch, useSearchBox } from "react-instantsearch";

// Mounted invisibly inside every InstantSearchNext root to claim ownership of
// the `query` UiState field. Without a SearchBox widget, react-instantsearch
// treats `query` as unowned and the custom stateMapping silently drops `q=`
// from the URL on the next state write — losing campaign / deep-link queries
// the moment a customer clicks any filter.
//
// Also forces a client-side search on mount. react-instantsearch-nextjs's
// `<InstantSearchNext>` always provides `InstantSearchSSRContext`, which puts
// react-instantsearch into "waiting for SSR results" mode. On client-side
// nav, the RSC payload doesn't include the SSR-injected
// `window[InstantSearchInitialResults]` script (Next.js's RSC streaming
// drops `ServerInsertedHTMLContext.insertHTML` output), so the client waits
// forever and never fires a fallback search - grid renders "0 products."
// Calling `refresh()` once on mount busts that deadlock.
export function PlpQueryOwner() {
  const $ = _c(3);
  useSearchBox();
  const {
    refresh
  } = useInstantSearch();
  let t0;
  let t1;
  if ($[0] !== refresh) {
    t0 = () => {
      refresh();
    };
    t1 = [refresh];
    $[0] = refresh;
    $[1] = t0;
    $[2] = t1;
  } else {
    t0 = $[1];
    t1 = $[2];
  }
  useEffect(t0, t1);
  return null;
}